module.exports = __webpack_public_path__ + "media/effects-10.69a0090e.webm";